// In-app links into the business hiring console.
//
// The console lives inside this same consumer app under the /business/* route
// tree (single origin, single port), alongside the /institution/* console. The
// /for-businesses marketing CTAs use these helpers, so they resolve to in-app
// paths — clicking "Get started" / "Sign in" enters the console on the same
// origin instead of a dead cross-port link.
export const BUSINESS_APP_URL = '/business';

export const businessSignupUrl = () => `${BUSINESS_APP_URL}/signup`;
export const businessLoginUrl = () => `${BUSINESS_APP_URL}/login`;
